export const styles = {
  secureConnectionAlert: {
    marginBottom: '24px',
  },
  timelineContainer: {
    paddingBottom: 'calc(100px + var(--ion-safe-area-bottom))',
  },
}
